var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAv5ArrowInCircle = function SvgAv5ArrowInCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-no-stroke": "true",
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#E6E5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-no-fill": "true",
    d: "m7 5 4.5 4L7 13.5",
    stroke: "#002774",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAv5ArrowInCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTggMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8Y2lyY2xlIGRhdGEtbm8tc3Ryb2tlPSJ0cnVlIiBjeD0iOSIgY3k9IjkiIHI9IjkiIGZpbGw9IiNFNkU1RkYiLz4KICAgIDxwYXRoIGRhdGEtbm8tZmlsbD0idHJ1ZSIgZD0iTTcgNUwxMS41IDlMNyAxMy41IiBzdHJva2U9IiMwMDI3NzQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";